module.exports = __webpack_public_path__ + "img/whats-app.ae41828.png";